<template>
  <div :class="$style.container">
    <TabList
      :activeTab="activeTabIndex"
      :class="$style.tabList"
      :customActiveTabStyle="$style.activeTab"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import { trialFeatures } from 'client/util/Constants/FeatureTrialConstants';
import MainPanelMixin from 'client/components/MainPanel/mixins/MainPanelMixin';
import PatchManagementPolicies from 'client/policies/PatchManagementPolicies';
import PoliciesMainPanel from 'client/components/MainPanel/PoliciesMainPanel';
import PoliciesMixin from 'client/OsManagement/mixins/PoliciesMixin';
import RouterService from 'client/util/RouterService';
import TabList from 'client/components/TabList/TabList';

const patchManagement = trialFeatures.osPatchManagement.featureCode;

export default {
  name: 'PoliciesTabsMainPanel',

  components: {
    TabList,
  },

  mixins: [MainPanelMixin, PoliciesMixin],

  props: {
    initialTabIndex: {
      type: Number,
      default: 0,
    },
    patchManagementTabIndex: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    activeTabIndex: 0,
  }),

  computed: {
    ...mapGetters('PlanModule', [
      'planHasFeature',
    ]),

    ...mapGetters('FeatureTrialModule', [
      'getPremiumBadgeProps',
    ]),

    premiumIconStyle() {
      return {
        'text-align': 'center',
        'background-color': 'var(--jcTertiary50)',
        'border-radius': '0.313rem',
        display: 'inline-block',
        'margin-right': '0.75rem',
        'line-height': '1',
        'font-size': '1rem',
        border: '1px solid var(--jcTertiary50)',
        padding: '0.25rem',
      };
    },

    tabs() {
      return [
        {
          title: 'All',
          component: PoliciesMainPanel,
          componentProps: {
            gettingStartedPanelItemType: ItemTypeConsts.configuration,
            isAsideOpen: false,
            itemType: ItemTypeConsts.configuration,
            selectedModelId: '',
            setSelectedModelId: this.setSelectedModelId,
          },
        },
        {
          title: 'Patch Management',
          component: PatchManagementPolicies,
          componentProps: {
            initialTabIndex: this.patchManagementTabIndex,
          },
          icon: this.showPremiumBadge(patchManagement) ? 'premiumDiscover' : '',
          iconStyle: this.premiumIconStyle,
          iconText: 'PREMIUM',
          iconPosition: 'right',
        },
      ];
    },

  },

  beforeMount() {
    this.activeTabIndex = this.initialTabIndex ? this.initialTabIndex : 0;
  },

  methods: {
    handleActiveTabChange(tabIndex) {
      let path = ItemTypeRoutes[ItemTypeConsts.configuration];
      if (tabIndex === 1) {
        path = ItemTypeRoutes[ItemTypeConsts.patchManagement];
      }

      this.activeTabIndex = tabIndex;
      RouterService.redirect({
        path,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },

    showPremiumBadge(featureCode) {
      return this.getPremiumBadgeProps(
        featureCode,
        { showDefaultPremiumBadgeVisibility: true },
      ).nonHeaderBadgeVisibility;
    },
  },
};
</script>

<style module>
.activeTab a {
  border-bottom: 2px solid var(--jcPrimary);
  color: var(--jcGrey600);
}

.container,
.tabList {
  height: 100%;
}

.tabLink {
  color: var(--jcGrey);
  font-size: 1.2rem;
  font-weight: bold;
  padding-bottom: 4px;
}

.tabNav {
  margin: 20px 0 10px 20px;
}
</style>
